import type { FieldReportListItem } from '@/modules/field/types';

type ReportWithStatus = Pick<FieldReportListItem, 'situation'> & {
  status?: string | null;
};

export function isCancelledFieldReport(report: ReportWithStatus): boolean {
  if (typeof report.status === 'string' && report.status.toLowerCase() === 'cancelled') {
    return true;
  }

  return report.situation === 'cancelled';
}

export function withoutCancelledFieldReports<T extends FieldReportListItem>(
  reports: T[],
): T[] {
  return reports.filter((report) => !isCancelledFieldReport(report));
}
